import api from "./api.js";

export default class CommonApi {
    static async createVisit() {
        return await api.post(`visitor`);
    }
}
